import { Mui } from "@osu/react-ui";
import QuickLinks from "./QuickLinks/components/";

function Home() {
  return (
    <Mui.Card className="padding-4">
      <QuickLinks />
    </Mui.Card>
  );
}

export default Home;
